var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('CartLink'),_c('FreQuent')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h3',{staticClass:"mt-3"},[_vm._v("Pharmacy Cart")])])
}]

export { render, staticRenderFns }